import { useMenu } from 'src/contexts/menu-context'
import type { ParentAndLinkItemProps } from '../../../global-navigation'
import { trackMenuPathDesktop } from '../../../utils'
import { Basic } from './Basic'
import { WithLogo } from './WithLogo'

export const LinkItem = ({
  item,
  type,
  level,
  position,
}: ParentAndLinkItemProps) => {
  const { state, handleDispatch } = useMenu()

  const handleTrack = () => {
    trackMenuPathDesktop(Number(type), state)
  }

  return (
    <a
      onMouseEnter={() =>
        type &&
        typeof position === 'number' &&
        typeof item.label === 'string' &&
        handleDispatch(type, position, item.label, Number(type))
      }
      onClick={() => handleTrack()}
      key={`list-menu-item-${position}`}
      className="cursor-pointer no-underline"
      href={item.labelURL ? item.labelURL : undefined}
    >
      {item.logoImage ? (
        <WithLogo item={item} level={level} position={position} />
      ) : (
        <Basic item={item} level={level} position={position} />
      )}
    </a>
  )
}
